module.exports = __webpack_public_path__ + "img/icon_1.2c3e842e.svg";